import { render, staticRenderFns } from "./PopupPageContent.vue?vue&type=template&id=2ba24560"
import script from "./PopupPageContent.vue?vue&type=script&lang=js"
export * from "./PopupPageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports